module.exports = __webpack_public_path__ + "static/media/camp.f7724ac4.svg";